module.exports = __webpack_public_path__ + "img/arrow-up-triangle-square.ecec9ff7.svg";